export default function PageTitleNoAdd(props) {
  return (
    <div id='page-title'>
      <div className='inner-container'>
        <h1>{props.pageTitle}</h1>
      </div>
    </div>
  );
}
